exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* START EVOQ COLOR PALETTE */\n/* END EVOQ COLOR PALETTE */\n/* START ATTENTION COLORS */\n/* END ATTENTION COLORS */\n/* SVG HOVER STATES */\nsvg {\n  fill: #C8C8C8;\n}\nsvg:hover {\n  fill: #6F7273;\n}\nsvg:active {\n  fill: #1E88C3;\n}\n/* END SVG HOVER STATES */\n._3O1XFCuoZS5F8iEuplLmiW {\n  padding: 0 20px;\n}\n._3O1XFCuoZS5F8iEuplLmiW .edit-provider {\n  float: left;\n  padding: 0px;\n  width: 100%;\n  border: 0px;\n  min-height: 80px;\n  padding: 10px 25px;\n}\n", ""]);

// Exports
exports.locals = {
	"providerSettingEditor": "_3O1XFCuoZS5F8iEuplLmiW"
};